import { validationTypes } from 'components/FormCreator/types';
import format from 'date-fns/format';
import { isValid } from 'date-fns';
import { timing } from 'constants/ui.constants';

export enum ReportType {
	Companies = 'Companies',
	Beneficiaries = 'Beneficiaries',
	BeneficiaryOnboarding = 'BeneficiaryOnboarding',
	Balances = 'Balances',
	Transactions = 'Transactions',
	Refunds = 'Refunds',
	PaymentFees = 'PaymentFees',
	ConversionFees = 'ConversionFees',
	AccountActivities = 'AccountActivities',
}

export interface ReportDetails {
	reportType?: string;
	dateRange?: any;
}

export const reportFieldsValidations: {
	[key in keyof Partial<ReportDetails>]: validationTypes[];
} = {
	reportType: [validationTypes.requierd],
	dateRange: [validationTypes.requierd],
};

export const reportTypes = [
	{ value: ReportType.Transactions, label: 'דו"ח תנועות כספיות' },
	{ value: ReportType.Balances, label: 'דו"ח שערוך יתרות לשקלים' },
	{ value: ReportType.Beneficiaries, label: 'דו"ח כל המוטבים' },
	{ value: ReportType.BeneficiaryOnboarding, label: 'דוח קליטת מוטבים' },
	{ value: ReportType.Companies, label: 'OPEN דו"ח לקוחות' },
	{ value: ReportType.Refunds, label: 'היסטוריית זיכויים' },
	{ value: ReportType.PaymentFees, label: 'דו"ח עמלות תשלום' },
	{ value: ReportType.ConversionFees, label: 'דו"ח עמלות המרה' },
	{ value: ReportType.AccountActivities, label: 'תנועות חשבון' },
];

export enum ReportInputFields {
	REPORT_TYPE = 'ReportType',
	DATE_RANGE = 'DateRange',
	COMPANY_NAME = 'CompanyName',
}

export const formatDate = (date: any) => {
	return isValid(new Date(date || '')) ? format(new Date(date || ''), timing.DATE) : date;
};

export const formatDateToLocaleString = (date: any) => {
	const options: any = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	};
	const dateObj = new Date(date);
	return format(dateObj, 'yyyy-MM-dd');
};
